import repository from './repsitory'

const resource = '/targets'

export default {
    get (type) {
        return repository.get(`${resource}/type/${type}`)
    },
    getActives () {
        return repository.get(`${resource}/active`)
    },
    getActivesByType (type) {
        return repository.get(`${resource}/active/type/${type}`)
    },
    getById (id) {
        return repository.get(`${resource}/${id}`)
    },
    add (data) {
        return repository.post(`${resource}`, data)
    },
    update (data, id) {
        return repository.put(`${resource}/${id}`, data)
    },
    getTypesForMenu (type) {
        return repository.get(`${resource}/typesForMenu`)
    },
    getComplice (startDate, endDate) {
        return repository.get(`${resource}/complice/${startDate}/${endDate}`)
    },
}
